// extracted by mini-css-extract-plugin
module.exports =  {"userSelect_none":"_0d624b9a27--userSelect_none--g_J_6","userSelect_auto":"_0d624b9a27--userSelect_auto--f5UVj","userSelect_all":"_0d624b9a27--userSelect_all--v9qxk"};